<template>
    <div class="w-full mt-20">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DASHBOARD ADMIN
                </h1>
            </div>
            <div w-full>
                <!-- <p class="text-xl text-center font-poppins mb-2">Halaman Admin untuk pengaturan daftar Rumah Sakit Umum Daerah Sultan Fatah, Silahkan memilih menu dibawah ini</p> -->
                <AdminMenu v-if="$page.url != '/auth/login'" class="mt-1 md:mt-10"/>
            </div>
        </div>
    </div>
</template>

<script>
import LayoutAdmin from "../../Shared/LayoutAdmin.vue";
import AdminMenu from "../../Shared/AdminMenu.vue";
export default {
    components: {
        AdminMenu
    },
    layout: LayoutAdmin
};
</script>
